import { useCallback } from 'react';
import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

export const useRepullReplenishment = () => {
  const { mutateAsync, isLoading, isError, isSuccess } = useMutation((invoiceId: string) =>
    api.post(API_URL.PREFUND_HISTORIES_INVOICES_RESUME_REPLENISHMENT_REJECT_BY_INVOICE_ID(invoiceId))
  );

  const handleRepull = useCallback(
    async (orgId: string) => {
      await mutateAsync(orgId);
    },
    [mutateAsync]
  );

  return {
    isLoading,
    isError,
    isSuccess,
    repull: handleRepull,
  };
};
